import {loadElementLottie, playLottie} from "./animations/lottie";
import {toggleBook} from "./book"
let CryptoJS = require("crypto-js");

export function getProducts(filterConfig = null, action = "init") {

    const shouldLoadInitialData = (action === "init" || !!window.location.hash);
    if (!shouldLoadInitialData) return;

    if (window.location.hash && !filterConfig) {
        const hash = window.location.hash.substring(1);
        const bytes = CryptoJS.AES.decrypt(hash, 'filter_string');
        filterConfig = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        filterConfig.offset = 0; // reset offset explicitly on refresh

    } else if (!filterConfig) {
        // If no hash and no explicit filterConfig, try loading from localStorage
        const storedConfig = localStorage.getItem('filterConfig');
        if (storedConfig) {
            filterConfig = JSON.parse(storedConfig);
            filterConfig.offset = 0; // reset offset explicitly on refresh
        } else {
            // fallback defaults
            filterConfig = { offset: 0, load_count: 12 };
        }
    } else {
        if(!filterConfig.load_more) {
            filterConfig.loaded_posts = 0;
            filterConfig.offset = 0; // reset offset explicitly on refresh
        }
    }

    const lazy = new LazyLoad();
    const product_list = $(".product-list");
    const products_wrap = product_list.find(".product-list-wrapper");
    const tags = $(".tax-filter-tags");
    const tags_wrap = tags.find(".tax-filter-tags-wrapper");
    const load_more_but = $(".load-more-products");
    const loaded_count = $("#loaded-count");
    const total_count = $("#total-count");

    product_list.addClass("loading").removeClass("loaded preloader-hidden");

    $.ajax({
        type: 'GET',
        url: "/API",
        dataType: 'json',
        data: { action: 'getProducts', data: filterConfig },
        success(result) {
            if (result.renderProducts && result.products) {
                const total_count_num = result.query_all;
                total_count.text(total_count_num);

                if (!filterConfig.load_more && filterConfig.offset === 0) {
                    products_wrap.html(result.renderProducts);
                    if ($(document).scrollTop() > $(".acf-page-title").height()) {
                        $('html, body').animate({ scrollTop: product_list.offset().top - 100 }, 600);
                    }
                } else {
                    products_wrap.append(result.renderProducts);
                }

                filterConfig.offset = $('.single-product').length;
                loaded_count.text(filterConfig.offset);

                // Simple and correct adjustment:
                const remainingProducts = total_count_num - filterConfig.offset;
                filterConfig.load_count = filterConfig.offset;
                filterConfig.load_more = false;

                if (remainingProducts > 0) {
                    load_more_but.removeClass("all-loaded").fadeIn("fast");
                } else {
                    load_more_but.addClass("all-loaded").hide();
                }

                const percentVal = (100 * $('.single-product').length) / total_count_num;
                setTimeout(() => load_more_but.find(".load-status .bar span").css("width", percentVal + "%"), 300);

                toggleBook();
                loadElementLottie($('.js-load-lottie'));
                loadElementLottie($('.js-load-lottie-cart'));
                lazy.update();

                load_more_but.find(".but.load-more").removeClass("preloading");
            } else {
                load_more_but.hide().removeClass("all-loaded");
                products_wrap.html(result.renderProducts);
            }

            product_list.removeClass("loading").addClass("loaded");

            setTimeout(() => product_list.addClass("preloader-hidden"), 300);
            setTimeout(() => product_list.removeClass("loaded"), 600);

            localStorage.setItem('filterConfig', JSON.stringify(filterConfig));

            if (!$('body').hasClass('page-template-search')) {
                const encrypt = CryptoJS.AES.encrypt(JSON.stringify(filterConfig), 'filter_string').toString();
                window.location.hash = encrypt;
            }

            if (!result.empty_filter) {
                tags_wrap.html(result.renderTags);
                tags.fadeIn("fast").removeClass("hidden");
            } else {
                tags.hide();
            }
        },
        error(err) {
            console.error("API Error:", err);
        }
    });
}


export function addToCart(me, id, amount) {

    let is_loading = true;

    if(!id) {
        if(is_logged) {
            let a = document.createElement('a');
            a.href = me.attr('href');
            a.setAttribute('target', '_blank');
            a.click();
            return true;
        } else {
            $("body").removeClass("show-fast-checkout");
            $("body").addClass("show-fast-login");
            $("html").removeClass("menu-opened");
            $(".mobile-menu-toggle").addClass("is-hidden");
        }

    } else {

        const lazy = new LazyLoad();
        const fast_checkout = $(".fast-checkout");

        let p = {
            id: id,
            amount: amount
        }

        if(me.hasClass("book-free") && !(me.hasClass("physical") || me.hasClass("printed"))) {
            if(p && is_loading) {

                $("body").addClass("loading");

                $.ajax({
                    type: 'GET',
                    url: "/API",
                    dataType: 'json',
                    data: {
                        action: 'instantDownload',
                        data: p
                    },
                    success: function(result) {
                        console.log(result);
                        $("body").removeClass("loading");

                        if(result.status) {
                            showDownload(result.download)
                        }

                    },
                    error: function(result) {
                        console.log(result.responseJSON);
                    }
                });

            }
        } else {

            if(me.hasClass("instant-checkout")) {
                console.log("instant-checkout")

                if(!is_logged) {
                    $("body").removeClass("show-fast-checkout");
                    $("body").addClass("show-fast-login free-download");
                    $("html").removeClass("menu-opened");
                    $(".mobile-menu-toggle").addClass("is-hidden");

                    $(".soc-logins a.skip-register").on("click tap", function() {
                        goToCheckout(p,is_loading);
                        return false;
                    });

                } else {
                    goToCheckout(p,is_loading);
                }

            } else {

                if(p && is_loading) {
                    fast_checkout.addClass("loading");
                    $("body").addClass("show-fast-checkout")
                    $("body").removeClass("show-search")
                    $(".mobile-menu-toggle").addClass("is-hidden");
                    console.log("add to cart " + id);

                    $.ajax({
                        type: 'GET',
                        url: "/API",
                        dataType: 'json',
                        data: {
                            action: 'addToCart',
                            data: p
                        },
                        success: function(result) {
                            console.log(result);

                            if(result.status) {

                                let cart = $(".js-load-lottie-cart")

                                if(result.cart_count) {
                                    $(".button.button--cart .cart-item-count").text(result.cart_count);
                                }

                                if(result.new_total) {
                                    $(".fast-checkout .bottom .total-amount p.sum").text(result.new_total + " Eur");
                                }

                                if(result.cart_count < 1) {
                                    fast_checkout.addClass("empty");
                                    fast_checkout.removeClass("empty");
                                } else {
                                    fast_checkout.removeClass("empty");
                                    fast_checkout.addClass("has-items");
                                }


                                $(".fast-checkout .body .cart-items").html(result.html)

                                playLottie(cart)
                                lazy.update()

                            } else {
                                $("body").removeClass("show-fast-checkout");
                                $("html").removeClass("menu-opened");
                                $(".mobile-menu-toggle").addClass("is-hidden");
                            }

                            is_loading = false
                            fast_checkout.removeClass("loading");

                            let p_count = $(".cart-items .p-count");
                            console.log("P_count",p_count)
                            console.log("P_count find",p_count.find("span").text() == "1")
                            p_count.each(function(index){
                                if($(this).find("span").text() == "1") {
                                    $(this).find("a.down").addClass("disabled");
                                } else {
                                    $(this).find("a.down").removeClass("disabled");
                                }
                            })


                        },
                        error: function(result) {
                            console.log(result.responseJSON);
                        }
                    });

                }
            }

        }

    }

}

export function renderFastCheckout() {

    const lazy = new LazyLoad();
    let fast_checkout = $(".fast-checkout");
    fast_checkout.find(".cart-items").html("")

    fast_checkout.addClass("loading");

    if(fast_checkout.hasClass("loading")) {
        $.ajax({
            type: 'GET',
            url: "/API",
            dataType: 'json',
            data: {
                action: 'renderFastCheckout',
            },
            success: function(result) {
                console.log(result);
                $(".button.button--cart .cart-item-count").text(result.cart_count);
                fast_checkout.find(".cart-items").html(result.html)
                fast_checkout.removeClass("loading");
                lazy.update()
            },
            error: function(result) {
                console.log(result.responseText);
            }
        });
    }

}

export function changeProductQuantity(me,key,quantity,max_q) {
    let parent = me.parent();
    let fast_checkout = $(".fast-checkout");
    let real_price = parent.data("real-price");
    let is_loading = 1;
    real_price = real_price * quantity;
    fast_checkout.addClass("loading");

    if($("html").hasClass("account")) {
        $("html").addClass("loading");
        let max_q = me.attr("max")
    }

    if(quantity > max_q) {
        quantity = max_q;
    }

    if(is_loading && is_loading && quantity <= max_q) {
        $.ajax({
            type: 'GET',
            url: "/API",
            dataType: 'json',
            data: {
                action: 'changeProductQuantity',
                data: {
                    key: key,
                    quantity: quantity
                }
            },
            success: function(result) {
                console.log(result);

                parent.find("span").text(quantity);

                if(real_price > 0) {
                    parent.parent().find(".p-info p").text(real_price.toFixed(2) + " Eur");
                }

                if(result.new_total) {
                    $(".fast-checkout .bottom .total-amount p.sum").text(result.new_total + " Eur");
                }

                $(".button.button--cart .cart-item-count").text(result.total_count);

                fast_checkout.removeClass("loading");

                if($("html").hasClass("account")) {
                    if(max_q) {
                        if(quantity <= max_q) {
                            console.log("do shipping update");
                            $("#update_checkout").trigger("click");
                        }
                    }

                    if(!result.status) {
                        me.val(max_q);
                    }

                }

                let p_count = $(".cart-items .p-count");

                p_count.each(function(index){
                    if($(this).find("span").text() == "1") {
                        $(this).find("a.down").addClass("disabled");
                    } else {
                        $(this).find("a.down").removeClass("disabled");
                    }
                })

                is_loading = 0;

            },
            error: function(result) {
                console.log(result.responseText);
            }
        });
    }

}

export function removeFromCart(me,id) {
    let cart_item = me.closest(".cart-item")
    let fast_checkout = $(".fast-checkout");
    fast_checkout.addClass("loading");

    if(fast_checkout.hasClass("loading")) {
        $.ajax({
            type: 'GET',
            url: "/API",
            dataType: 'json',
            data: {
                action: 'removeFromCart',
                data: {
                    id: id
                }
            },
            success: function(result) {
                console.log(result);

                if (result.status) {
                    cart_item.fadeOut("fast")
                } else {
                    $(".fast-checkout .body .cart-items").html(result.html)
                }

                if(result.new_total) {
                    $(".fast-checkout .bottom .total-amount p.sum").text(result.new_total + " Eur");
                }

                console.log(result.total_count);

                if(result.total_count >= 1) {
                    fast_checkout.removeClass("empty");
                    fast_checkout.addClass("has-items");
                } else {
                    fast_checkout.removeClass("has-items");
                    fast_checkout.addClass("empty");
                }

                $(".button.button--cart .cart-item-count").text(result.total_count);

                fast_checkout.removeClass("loading");
            },
            error: function(result) {
                console.log(result.responseText);
            }
        });
    }

}

export function subscribe(me, data) {

    let formData = {};

    $.each(data, function() {

        if (this.value) {
            formData[this.name] = this.value;
        }

    });

    let but = me.find("span");
    let input = me.find("input");
    let response = me.parent().find(".response");

    response.removeClass("error")
    response.html("")
    but.text("uzgaidi...");

    me.addClass("success");
    var form_container = $("#mailerlite-form_2 form .mailerlite-subscribe-submit");
    console.log("Triggering submit")
    form_container.trigger('click')
    // if(formData) {
    //     $.ajax({
    //         type: 'GET',
    //         url: "/API",
    //         dataType: 'json',
    //         data: {
    //             action: 'subscribe',
    //             data: formData
    //         },
    //         success: function(result) {
    //             console.log(result);

    //             if(!result.status) {
    //                 console.log("kļūda")
    //                 input.val("")
    //                 me.addClass("show-error")
    //                 but.text(me.data("text-error"))

    //                 response.addClass("error")

    //                 if(result.message) {
    //                     response.html(result.message)
    //                 } else {
    //                     response.html(result.data.errors[-1][0])
    //                 }

    //                 setTimeout(function () {
    //                     me.removeClass("success")
    //                     but.text(me.data("text-button"))
    //                 },1600);

    //                 setTimeout(function () {
    //                     me.removeClass("show-error")
    //                 },1800);

    //             } else {
    //                 input.val("")
    //                 but.text(me.data("text-success"));

    //                 setTimeout(function () {
    //                     but.text(me.data("text-button"));
    //                     me.removeClass("success")
    //                 },1800);

    //             }


    //         },
    //         error: function(result) {
    //             console.log(result.responseText);
    //         }
    //     });
    // }
}

export function postReview(me, data) {

    let formData = {};
    let req = me.find(".req");
    let comment_title = me.find(".comment_title");
    let submit_comment = me.find(".button_2.submit-request");
    let comment = me.find(".comment");
    let my_rating = $(".my-rating");
    let err = 0;

    $.each(data, function() {

        if (this.value) {
            formData[this.name] = this.value;
        }

    });

    if (formData) {

        req.each(function () {

            let me = $(this);

            if(me.val() === "") {
                me.parent().addClass("error");
                me.parent().parent().addClass("has-error");
                me.parent().parent().find("p.error").text(me.data("text-error"))
                err++;
            } else {
                me.parent().removeClass("error");
                me.parent().parent().find("p.error").text("")
                me.parent().parent().removeClass("has-error");
            }

        });

        if(formData.rating < 1) {
            my_rating.addClass("error");
            err++;
        } else {
            my_rating.removeClass("error");
        }

    }

    if(!err && formData) {
        me.removeClass("has-errors");
        $(".post-review .form-success").hide();
        submit_comment.addClass("loading");

        setTimeout(function () {
            submit_comment.addClass("animating");
        },500)

        $.ajax({
            type: 'GET',
            url: "/API",
            dataType: 'json',
            cache: false,
            data: {
                action: 'postReview',
                data: formData
            },
            success: function(result) {

                console.log(result);

                if(result.status) {
                    // console.log(result);
                    submit_comment.addClass("completed");

                    setTimeout(function () {
                        submit_comment.removeClass("loading");
                        submit_comment.addClass("finished");
                    },1000)

                    setTimeout(function () {
                        submit_comment.removeClass("finished completed animating");
                        formSend();
                    },2500)
                    setTimeout(function(){
                        $(".post-review .form-success").hide()
                    },4500)
                } else {
                    submit_comment.removeClass("loading animating");

                    if(result.errors) {
                        me.addClass("has-errors");

                        $.each( result.errors, function(key, value ) {

                            if(value.type == "comment_title") {
                                comment_title.parent().addClass("error");
                                comment_title.parent().parent().find(".response p.error").text(value.message);
                            }

                            if(value.type == "comment") {
                                comment.parent().addClass("error");
                                comment.parent().parent().find(".response p.error").text(value.message);
                            }

                        });
                    }


                }

            },
            error: function(result) {
                console.log(result.responseText);
            }
        });

    } else {
        me.addClass("has-errors");
    }

    function formSend() {
        $(".post-review .my-rating .stars").attr("class","stars");
        $(".post-review  .field input").val("");
        $(".post-review  .field textarea").val("");
        $(".post-review  input#rating").val(0);
        $(".post-review form label .response .count-letters p.current").text("0");
        $(".post-review .form-success").stop().fadeIn("fast");
    }

}

export function loginUser(me,data) {

    if(me == "facebook") {
        console.log(data)
    } else {
        let formData = {};
        let err = 0;

        let req = me.find(".req");
        let woo_email = me.find(".woo_email");
        let woo_password = me.find(".woo_password");
        let submit_login = me.find(".button_2.submit-request");

        $.each(data, function() {

            if (this.value) {
                formData[this.name] = this.value;
            }

        });

        if (formData) {

            let validate_email = validateEmail(formData.woo_email);

            req.each(function () {

                let me = $(this);

                if(!validate_email) {
                    woo_email.parent().addClass("error");
                    woo_email.parent().parent().addClass("has-error");
                    woo_email.parent().parent().find("p.error").text(me.data("text-error"))
                    err++;
                } else {
                    woo_email.parent().removeClass("error");
                    woo_email.parent().parent().find("p.error").text("")
                    woo_email.parent().parent().removeClass("has-error");
                }

                if(me.val() === "") {
                    me.parent().addClass("error");
                    me.parent().parent().addClass("has-error");
                    me.parent().parent().find("p.error").text(me.data("text-error"))
                    err++;
                } else {
                    me.parent().removeClass("error");
                    me.parent().parent().find("p.error").text("")
                    me.parent().parent().removeClass("has-error");
                }

            });

        }

        if(!err && formData) {

            me.removeClass("has-errors");
            $(".post-review .form-success").hide();
            submit_login.addClass("loading");

            setTimeout(function () {
                submit_login.addClass("animating");
            },500)

            $.ajax({
                type: 'GET',
                url: "/API",
                dataType: 'json',
                cache: false,
                data: {
                    action: 'loginUser',
                    data: formData
                },
                success: function(result) {

                    if(result) {

                        console.log(result);
                        if(result.status) {
                            window.location.reload();
                        } else {
                            submit_login.addClass("completed");

                            if(result.message.errors) {

                                $.each( result.message.errors, function(key, value ) {

                                    if(key == "invalid_email" || key == "alg_wc_ev_email_verified_error") {
                                        console.log('not verified')
                                        woo_email.parent().parent().addClass("has-error");
                                        woo_email.parent().addClass("error");
                                        woo_email.parent().parent().find(".response p.error").html(value[0]);
                                    }

                                    if(key == "incorrect_password") {
                                        woo_password.parent().parent().addClass("has-error");
                                        woo_password.parent().addClass("error");
                                        woo_password.parent().parent().find(".response p.error").html(value[0]);
                                    }


                                });

                                setTimeout(function () {
                                    submit_login.removeClass("loading");
                                    submit_login.addClass("finished");
                                },1000)

                                setTimeout(function () {
                                    submit_login.removeClass("finished completed animating");
                                },2500)

                            }
                        }

                    }

                },

                error: function(result) {
                    console.log(result.responseText);
                }
            });

        }
    }

}

export function registerUser(me,data) {

    if(me == "facebook" || me == "google") {

        $(".sidebars.fast-login").addClass("loading");

        $.ajax({
            type: 'GET',
            url: "/API/",
            dataType: 'json',
            cache: false,
            data: {
                action: 'registerUser',
                data: data,
            },
            success: function(result) {
                console.log('here')
                if(!result.status) {
                    $('#soc-errors').text("Pārbaudiet savu e-pastu, lai aktivizētu kontu!")
                    $(".sidebars.fast-login").removeClass("loading");
                } else
                    window.location.reload();
            },

            error: function(result) {
                console.log(result.responseText);
            }
        });

    } else {

        let formData = {};
        let err = 0;

        let req = me.find(".req");
        let nice = me.find(".nice.req");
        let submit_register = me.find(".button_2.submit-request");
        let woo_email = me.find(".woo_email");
        let woo_password = me.find(".woo_password");
        let woo_password_again = me.find(".woo_password_again");

        $.each(data, function() {

            if (this.value) {
                formData[this.name] = this.value;
            }

        });

        if (formData) {

            let validate_email = validateEmail(formData.woo_email);

            req.each(function () {

                let me = $(this);

                if(formData.woo_password !== formData.woo_password_again ) {
                    woo_password.parent().addClass("error");
                    woo_password.parent().parent().addClass("has-error");
                    woo_password.parent().parent().find("p.error").text("Paroles nesakrīt")
                    woo_password_again.parent().addClass("error");
                    woo_password_again.parent().parent().addClass("has-error");
                    woo_password_again.parent().parent().find("p.error").text("Paroles nesakrīt")
                    err++;
                }

                if(!validate_email) {
                    woo_email.parent().addClass("error");
                    woo_email.parent().parent().addClass("has-error");
                    woo_email.parent().parent().find("p.error").text(me.data("text-error"))
                    err++;
                } else {
                    woo_email.parent().removeClass("error");
                    woo_email.parent().parent().find("p.error").text("")
                    woo_email.parent().parent().removeClass("has-error");
                }

                if(me.val() === "") {
                    me.parent().addClass("error");
                    me.parent().parent().addClass("has-error");
                    me.parent().parent().find("p.error").text(me.data("text-error"))
                    err++;
                } else {
                    me.parent().removeClass("error");
                    me.parent().parent().find("p.error").text("")
                    me.parent().parent().removeClass("has-error");
                }

                if(!nice.is(':checked')) {
                    nice.addClass("error");
                    nice.parent().addClass("has-error");
                    err++;
                } else {
                    nice.removeClass("error");
                    nice.parent().removeClass("has-error");
                }

            });

        }

        if(!err && formData) {

            me.removeClass("has-errors");
            $(".post-review .form-success").hide();
            submit_register.addClass("loading");

            setTimeout(function () {
                submit_register.addClass("animating");
            },500)

            console.log(formData);
            $.ajax({
                type: 'GET',
                url: "/API",
                dataType: 'json',
                cache: false,
                data: {
                    action: 'registerUser',
                    data: formData
                },
                success: function(result) {

                    if(result) {
                        console.log(result);

                        if(result.status) {
                            $('.account-content').addClass('paslept')
                            $('.account-registered').removeClass('paslept')
                            var animation = document.getElementById('successAnimation');

                            // setTimeout(function () {
                            //     window.location.href = result.redirect + "#login"
                            // },2500)
                        } else {

                            if(result.message.errors) {
                                submit_register.addClass("completed");

                                $.each( result.message.errors, function(key, value ) {

                                    if(key === "existing_user_email") {
                                        woo_email.parent().parent().addClass("has-error");
                                        woo_email.parent().addClass("error");
                                        woo_email.parent().parent().find(".response p.error").html(value[0]);
                                    }

                                    if(key === "existing_user_login") {
                                        woo_email.parent().parent().addClass("has-error");
                                        woo_email.parent().addClass("error");
                                        woo_email.parent().parent().find(".response p.error").html(value[0]);
                                    }


                                });

                                setTimeout(function () {
                                    submit_register.removeClass("loading");
                                    submit_register.addClass("finished");
                                },1000)

                                setTimeout(function () {
                                    submit_register.removeClass("finished completed animating");
                                },2500)

                            }

                        }

                    }

                },

                error: function(result) {
                    console.log(result.responseText);
                }
            });

        }

    }

}

export function forgotPassword(me,data) {

    let formData = {};
    let err = 0;
    let req = me.find(".req");
    let submit_forgot = me.find(".button_2.submit-request");
    let woo_email = me.find(".woo_email");

    $.each(data, function() {

        if (this.value) {
            formData[this.name] = this.value;
        }

    });

    if (formData) {

        console.log(formData)

        let validate_email = validateEmail(formData.woo_email);

        req.each(function () {

            let me = $(this);

            if(!validate_email) {
                woo_email.parent().addClass("error");
                woo_email.parent().parent().addClass("has-error");
                woo_email.parent().parent().find("p.error").text(me.data("text-error"))
                err++;
            } else {
                woo_email.parent().removeClass("error");
                woo_email.parent().parent().find("p.error").text("")
                woo_email.parent().parent().removeClass("has-error");
            }

            if(me.val() === "") {
                me.parent().addClass("error");
                me.parent().parent().addClass("has-error");
                me.parent().parent().find("p.error").text(me.data("text-error"))
                err++;
            } else {
                me.parent().removeClass("error");
                me.parent().parent().find("p.error").text("")
                me.parent().parent().removeClass("has-error");
            }

        });

    }

    if(!err && formData) {

        me.removeClass("has-errors");
        submit_forgot.addClass("loading");

        setTimeout(function () {
            submit_forgot.addClass("animating");
        },500)

        // console.log(formData)

        $.ajax({
            type: 'GET',
            url: "/API",
            dataType: 'json',
            cache: false,
            data: {
                action: 'forgotPassword',
                data: formData
            },
            success: function(result) {

                if(result.status) {
                    console.log(result);
                    $(".account-content .auth").html(result.html)
                    let check = $(".js-load-lottie-check");
                    loadElementLottie(check)
                } else {
                    if(result.message) {
                        submit_forgot.addClass("completed");

                        woo_email.parent().parent().addClass("has-error");
                        woo_email.parent().addClass("error");
                        woo_email.parent().parent().find(".response p.error").html(result.message);
                    }
                }

                setTimeout(function () {
                    submit_forgot.removeClass("loading");
                    submit_forgot.addClass("finished");
                },1000)

                setTimeout(function () {
                    submit_forgot.removeClass("finished completed animating");
                },2500)

            },

            error: function(result) {
                console.log(result.responseText);
            }
        });

    }

}


export function updateProfile(me,data) {

    let formData = {};
    let err = 0;
    let req = me.find(".req");
    let submit_update = me.find(".button_2.submit-request");
    let woo_email = me.find(".woo_email");

    $.each(data, function () {

        if (this.value) {
            formData[this.name] = this.value;
        }

    });

    if (formData) {

        let validate_email = validateEmail(formData.billing_email);

        req.each(function () {

            let me = $(this);

            if(!validate_email) {
                woo_email.parent().addClass("error");
                woo_email.parent().parent().addClass("has-error");
                woo_email.parent().parent().find("p.error").text(me.data("text-error"))
                err++;
            } else {
                woo_email.parent().removeClass("error");
                woo_email.parent().parent().find("p.error").text("")
                woo_email.parent().parent().removeClass("has-error");
            }

            if(me.val() === "") {
                me.parent().addClass("error");
                me.parent().parent().addClass("has-error");
                me.parent().parent().find("p.error").text(me.data("text-error"))
                err++;
            } else {
                me.parent().removeClass("error");
                me.parent().parent().find("p.error").text("")
                me.parent().parent().removeClass("has-error");
            }

        });

    }

    if(!err && formData) {

        me.removeClass("has-errors");
        submit_update.addClass("loading");

        setTimeout(function () {
            submit_update.addClass("animating");
        }, 500)

        $.ajax({
            type: 'GET',
            url: "/API",
            dataType: 'json',
            cache: false,
            data: {
                action: 'updateProfile',
                data: formData
            },
            success: function(result) {

                console.log(result);

                setTimeout(function () {
                    submit_update.removeClass("loading");
                    submit_update.addClass("finished");
                },1000)

                setTimeout(function () {
                    submit_update.removeClass("finished completed animating");
                },2500)

            },

            error: function(result) {
                console.log(result.responseText);
            }
        });

    }

}

export function updatePassword(me,data) {

    let formData = {};
    let err = 0;
    let req = me.find(".req");
    let submit_update = me.find(".button_2.submit-request");
    let woo_password = me.find(".woo_password");
    let woo_new_password = me.find(".woo_new_password");
    let woo_new_password_again = me.find(".woo_new_password_again");

    $.each(data, function () {

        if (this.value) {
            formData[this.name] = this.value;
        }

    });

    if (formData) {

        req.each(function () {

            let me = $(this);

            if(formData.woo_new_password !== formData.woo_new_password_again ) {
                woo_new_password.parent().addClass("error");
                woo_new_password.parent().parent().addClass("has-error");
                woo_new_password.parent().parent().find("p.error").text("Paroles nesakrīt")
                woo_new_password_again.parent().addClass("error");
                woo_new_password_again.parent().parent().addClass("has-error");
                woo_new_password_again.parent().parent().find("p.error").text("Paroles nesakrīt")
                err++;
            }

            if(me.val() === "") {
                me.parent().addClass("error");
                me.parent().parent().addClass("has-error");
                me.parent().parent().find("p.error").text(me.data("text-error"))
                err++;
            } else {
                me.parent().removeClass("error");
                me.parent().parent().find("p.error").text("")
                me.parent().parent().removeClass("has-error");
            }

        });

    }

    if(!err && formData) {

        me.removeClass("has-errors");
        submit_update.addClass("loading");

        setTimeout(function () {
            submit_update.addClass("animating");
        }, 500)

        $.ajax({
            type: 'GET',
            url: "/API",
            dataType: 'json',
            cache: false,
            data: {
                action: 'updatePassword',
                data: formData
            },
            success: function(result) {

                console.log(result);

                if(result.status) {
                    window.location.href = "/#login";
                } else {

                    me.addClass("has-errors");

                    woo_password.parent().addClass("error");
                    woo_password.parent().parent().addClass("has-error");
                    woo_password.parent().parent().find("p.error").text(result.message)

                    setTimeout(function () {
                        submit_update.removeClass("loading");
                        submit_update.addClass("finished");
                    },1000)

                    setTimeout(function () {
                        submit_update.removeClass("finished completed animating");
                    },2500)
                }

            },

            error: function(result) {
                console.log(result.responseText);
            }
        });

    }

}

export function updateAddress(me,data) {

    let formData = {};
    let err = 0;
    let submit_update = me.find(".button_2.submit-request");

    $.each(data, function () {

        if (this.value) {
            formData[this.name] = this.value;
        }

    });

    if (formData) {

        console.log(formData)

        if(formData.billing_phone) {
            $("input.billing_phonecode").addClass("req");

            let value = formData.billing_phone;
            let mobile = value.replace(/ /g,'');

            if(value.slice(0,1)=='+'){
                mobile = mobile.substring(4)
            }

            $("input.billing_phone").val(mobile)

        } else {
            // $("input.billing_phonecode").removeClass("req");
            // $("input.billing_phonecode").parent().removeClass("error");
            // $("input.billing_phonecode").parent().parent().removeClass("has-error");
        }

        // if(formData.billing_phonecode) {
        //     $("input.billing_phone").addClass("req");
        // } else {
        //     $("input.billing_phone").removeClass("req");
        //     $("input.billing_phone").removeClass("req");
        //     $("input.billing_phone").parent().removeClass("error");
        //     $("input.billing_phone").parent().parent().removeClass("has-error");
        // }

        let req = me.find(".req");

        req.each(function () {

            let me = $(this);

            if(me.val() === "" || me.val() === null) {
                me.parent().addClass("error");
                me.parent().parent().addClass("has-error");
                me.parent().parent().find("p.error").text(me.data("text-error"))
                err++;
            } else {
                me.parent().removeClass("error");
                me.parent().parent().removeClass("has-error");
                me.parent().parent().find("p.error").text("")
            }

        });

    }

    if(!err && formData) {

        me.removeClass("has-errors");
        submit_update.addClass("loading");

        setTimeout(function () {
            submit_update.addClass("animating");
        }, 500)

        $.ajax({
            type: 'GET',
            url: "/API",
            dataType: 'json',
            cache: false,
            data: {
                action: 'updateAddress',
                data: formData
            },
            success: function(result) {
                console.log(result);

                setTimeout(function () {
                    submit_update.removeClass("loading");
                    submit_update.addClass("finished");
                },1000)

                setTimeout(function () {
                    submit_update.removeClass("finished completed animating");
                },2500)

            },

            error: function(result) {
                console.log(result.responseText);
            }
        });

    }

}

export function deleteUser(me,data) {

    if(me.hasClass("facebook") || me.hasClass("google")) {
        let type;

        if (me.hasClass("facebook")) {
            type = "facebook";
        }

        if (me.hasClass("google")) {
            type = "google";
        }

        $("html").addClass("loading");

        $.ajax({
            type: 'GET',
            url: "/API",
            dataType: 'json',
            cache: false,
            data: {
                action: 'deleteUser',
                data: {
                    _wpnonce: me.data("nonce-register"),
                    type: type,
                    username: me.data("username"),
                },
            },
            success: function(result) {
                console.log(result);
                if(result.status) {
                    window.location.href = "/";
                }
            },

            error: function(result) {
                console.log(result.responseText);
            }
        });

    } else {
        let formData = {};
        let err = 0;
        let req = me.find(".req");
        let submit_update = me.find(".button_2.submit-request");
        let woo_password = me.find(".woo_password");

        $.each(data, function () {

            if (this.value) {
                formData[this.name] = this.value;
            }

        });

        if (formData) {

            req.each(function () {

                let me = $(this);

                if (me.val() === "" || me.val() === null) {
                    me.parent().addClass("error");
                    me.parent().parent().addClass("has-error");
                    me.parent().parent().find("p.error").text(me.data("text-error"))
                    err++;
                } else {
                    me.parent().removeClass("error");
                    me.parent().parent().find("p.error").text("")
                    me.parent().parent().removeClass("has-error");
                }

            });

        }

        if (!err && formData) {

            me.removeClass("has-errors");
            submit_update.addClass("loading");

            setTimeout(function () {
                submit_update.addClass("animating");
            }, 500)

            $.ajax({
                type: 'GET',
                url: "/API",
                dataType: 'json',
                cache: false,
                data: {
                    action: 'deleteUser',
                    data: formData
                },
                success: function(result) {

                    // console.log(result);

                    if(result.status) {
                        window.location.href = "/";
                    } else {

                        me.addClass("has-errors");

                        woo_password.parent().addClass("error");
                        woo_password.parent().parent().addClass("has-error");
                        woo_password.parent().parent().find("p.error").text(result.message)

                        setTimeout(function () {
                            submit_update.removeClass("loading");
                            submit_update.addClass("finished");
                        },1000)

                        setTimeout(function () {
                            submit_update.removeClass("finished completed animating");
                        },2500)
                    }

                },

                error: function(result) {
                    console.log(result.responseText);
                }
            });

        }
    }

}



function validateEmail(email) {
    var re = /\S+@\S+\.\S+/;
    return re.test(email);
}

let downloadCountdownInterval = null;

function showDownload(url) {
    $("body").addClass('show-download-countdown');
    $(".mobile-menu-toggle").addClass("is-hidden");
    $(".download-countdown a.button_2").attr("href", url);

    let num = 5;

    downloadCountdownInterval = setInterval(function() {
        num--;

        if (num > -1) {
            $(".download-countdown span.number").text(num);
        } else {
            stopDownloadCountdown(); // Clean up properly
            window.location.href = url;
        }
    }, 1000);
}

export function stopDownloadCountdown() {
    if (downloadCountdownInterval) {
        clearInterval(downloadCountdownInterval);
        downloadCountdownInterval = null;
    }
    $("body").removeClass('show-download-countdown');
    $(".mobile-menu-toggle").removeClass("is-hidden");
    $(".download-countdown a.button_2").attr("href", "#");
    $(".download-countdown span.number").text("5");
}

function goToCheckout(p,is_loading) {

    if(p && is_loading) {

        $("body").addClass("loading");

        $.ajax({
            type: 'GET',
            url: "/API",
            dataType: 'json',
            data: {
                action: 'addToCart',
                data: p
            },
            success: function(result) {
                console.log(result);

                if(result.status) {
                    window.location.href = "/pirkums";
                }

            },
            error: function(result) {
                console.log(result.responseJSON);
            }
        });
    }

}